import { CheckIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

import { Step } from '../hooks/use-resume-tailor'

const steps = [
  { id: 'upload', label: 'Upload', description: 'Resume & Job' },
  { id: 'analyze', label: 'Analyze', description: 'AI Review' },
  { id: 'result', label: 'Result', description: 'Tailored Resume' },
]

export const Stepper = (props: { step: Step }) => {
  const { step } = props

  const getStepStatus = (stepId: string) => {
    const stepOrder = ['upload', 'analyze', 'result']
    const currentIndex = stepOrder.indexOf(step)
    const stepIndex = stepOrder.indexOf(stepId)

    if (stepIndex < currentIndex) return 'completed'
    if (stepIndex === currentIndex) return 'current'
    return 'upcoming'
  }

  return (
    <div className="mb-10 flex items-center justify-center">
      <div className="flex items-center">
        {steps.map((s, index) => {
          const status = getStepStatus(s.id)
          const isCompleted = status === 'completed'
          const isCurrent = status === 'current'

          return (
            <div key={s.id} className="flex items-center">
              {/* Step */}
              <div className="flex flex-col items-center">
                {/* Step circle */}
                <div
                  className={cn(
                    'flex h-10 w-10 items-center justify-center rounded-full text-sm font-medium transition-all duration-300',
                    isCompleted && 'bg-primary text-primary-foreground',
                    isCurrent &&
                      'bg-primary text-primary-foreground ring-4 ring-primary/20',
                    !isCompleted &&
                      !isCurrent &&
                      'bg-muted text-muted-foreground',
                  )}
                >
                  {isCompleted ? (
                    <CheckIcon className="h-5 w-5" />
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>

                {/* Labels */}
                <div className="mt-2 flex flex-col items-center">
                  <span
                    className={cn(
                      'text-sm font-medium transition-colors',
                      isCompleted || isCurrent
                        ? 'text-foreground'
                        : 'text-muted-foreground',
                    )}
                  >
                    {s.label}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {s.description}
                  </span>
                </div>
              </div>

              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="mx-4 mb-8">
                  <div
                    className={cn(
                      'h-0.5 w-16 rounded-full transition-colors duration-300 sm:w-24',
                      getStepStatus(steps[index + 1].id) !== 'upcoming'
                        ? 'bg-primary'
                        : 'bg-muted',
                    )}
                  />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
